// apps/app/src/features/chat/Messages/Item/ReactionsPick.tsx
import { IconButton } from '@/components/ui/icon-button'
import * as Popover from '@/components/ui/popover'
import { EmojiPicker } from '@components'
import { SmilePlus } from 'lucide-solid'
import { createSignal } from 'solid-js'
import { Portal } from 'solid-js/web'

interface ReactionsPickProps {
  onReaction: (emoji: string) => void
}

export default function (props: ReactionsPickProps) {
  const [isOpen, setIsOpen] = createSignal(false)

  const handleSelect = (emoji: string) => {
    // Optimistic update means we can close the popover instantly
    props.onReaction(emoji)
    setIsOpen(false)
  }

  return (
    <>
      <Popover.Root
        open={isOpen()}
        onOpenChange={({ open }) => setIsOpen(open)}
        positioning={{
          offset: { mainAxis: -15 },
        }}
      >
        <Popover.Trigger
          asChild={(props) => (
            <IconButton {...props} size="xs" variant="plain" type="button">
              <SmilePlus width='15px' height='15px' />
            </IconButton>
          )}
        />
        <Portal>
          <Popover.Positioner>
            <Popover.Content p={0}>
              <Popover.Arrow>
                <Popover.ArrowTip />
              </Popover.Arrow>
              <EmojiPicker onSelect={handleSelect} />
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
    </>
  )
}
